var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGardenDashboardPlantingSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GardenDashboardPlantingSVG 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "connector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45.4133 54.5248L57.0006 43.1146",
    stroke: "#065D44",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconHandle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M52.4221 38.0562L56.5395 42.5811L61.1283 47.8309C61.1283 47.8309 66.8307 42.3469 73.4576 36.0211C80.9059 28.9111 86.0492 23.9178 89.4385 20.6721C93.0408 17.2224 93.532 11.4842 90.7158 8.87469C87.5285 5.92143 82.1785 7.52119 78.9201 10.8086C76.1949 13.558 69.7523 20.3244 63.6111 26.5609C57.4701 32.7975 52.4221 38.0562 52.4221 38.0562Z",
    stroke: "#065D44",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "spade"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M32.9895 41.4453L58.3516 68.2824C58.3516 68.2824 21.3613 100.979 10.5225 89.3641C-1.48855 76.4932 32.9895 41.4453 32.9895 41.4453Z",
    stroke: "#065D44",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGardenDashboardPlantingSvg);
export default __webpack_public_path__ + "static/media/GardenDashboardPlantingSVG.e93c8828b50fd2ee7485aa5c551d0001.svg";
export { ForwardRef as ReactComponent };